import { revenueGridLines, revenuePlotConfig, type RevenueRange } from '../../data/revenue'
import { cn } from '../../utils/cn'
import { absoluteBox } from '../../utils/geometry'
import { MoneyLabel } from '../ui/MoneyLabel'

type RevenueGridProps = {
  range: RevenueRange
  xLabels: readonly string[]
  activeIndex: number
  /** When provided (API/mock series), overrides the static axis scale for that range. */
  axisLabels?: readonly string[]
}

/** Gridlines, baseline, currency scale and month ticks of the revenue chart. */
export const RevenueGrid = ({
  range,
  xLabels,
  activeIndex,
  axisLabels: axisLabelsProp,
}: RevenueGridProps) => {
  const axisLabels = axisLabelsProp ?? revenuePlotConfig[range].axisLabels

  return (
    <>
      {revenueGridLines.map((line) => (
        <div key={line.id} className="absolute h-0" style={absoluteBox(line)}>
          <span className="absolute -top-px bottom-0 left-0 right-0 block">
            <img alt="" aria-hidden className="block size-full max-w-none" src={line.src} />
          </span>
        </div>
      ))}

      <div className="absolute flex flex-col items-start gap-[36px]" style={absoluteBox({ x: 13, y: 121, width: 37 })}>
        {axisLabels.map((label) => (
          <MoneyLabel key={`${range}-${label}`} amount={label} tone="light" />
        ))}
      </div>

      <div
        className="absolute flex items-center justify-between"
        style={absoluteBox({ x: 62, y: 320, width: 368 })}
      >
        {xLabels.map((label, index) => (
          <p
            key={`${range}-${label}`}
            className={cn(
              'whitespace-nowrap font-host text-[16px] font-semibold leading-normal transition-colors duration-200 motion-reduce:transition-none',
              index === activeIndex ? 'text-dash-chart-label' : 'text-white',
            )}
          >
            {label}
          </p>
        ))}
      </div>
    </>
  )
}
